import React from 'react';
import { motion } from 'framer-motion';
import { THEME } from '../../utils/theme';

const MobileStatusPicker = ({ isOpen, onClose, statusTab, onStatusChange, lfgMode, onLfgToggle, stats }) => {
  if (!isOpen) return null;

  const statusOptions = [
    { value: 'lfg', label: '🎮 LFG', count: stats?.lfg_games || 0, isLfg: true, gradient: true },
    { value: 'all', label: 'All Games', count: stats?.total_games || 0 },
    { value: 'played', label: 'Played', count: stats?.played_games || 0, color: THEME.success },
    { value: 'wtp', label: 'Want to Play', count: stats?.wtp_games || 0, color: THEME.warning },
    { value: 'never', label: 'Never Again', count: stats?.never_games || 0, color: THEME.danger },
    { value: 'unplayed', label: 'Unplayed', count: stats?.unplayed_games || 0, color: THEME.textMuted },
  ];

  return (
    <>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} style={{ position: 'fixed', inset: 0, background: 'rgba(5,5,10,0.6)', zIndex: 1000, backdropFilter: 'blur(8px)' }} onClick={onClose} />
      <motion.div initial={{ y: '100%' }} animate={{ y: 0 }} exit={{ y: '100%' }} transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }} style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: `linear-gradient(180deg, ${THEME.bgCard} 0%, ${THEME.bgElevated} 100%)`, borderTopLeftRadius: '24px', borderTopRightRadius: '24px', zIndex: 1001, paddingBottom: 'env(safe-area-inset-bottom, 16px)', border: `1px solid ${THEME.glassBorder}`, borderBottom: 'none', boxShadow: '0 -16px 48px rgba(0, 0, 0, 0.4)' }}>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '12px' }}>
          <div style={{ width: '40px', height: '4px', background: THEME.borderLight, borderRadius: '2px' }} />
        </div>
        <div style={{ padding: '0 16px 16px' }}>
          <h3 style={{ margin: '0 0 16px', color: THEME.text, fontSize: '16px', fontWeight: '700' }}>Filter by Status</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {statusOptions.map(opt => {
              const isActive = opt.isLfg ? lfgMode : (!lfgMode && statusTab === opt.value);
              return (
                <button
                  key={opt.value}
                  onClick={() => {
                    if (opt.isLfg) { onLfgToggle(); }
                    else { onStatusChange(opt.value); }
                    onClose();
                  }}
                  className="press-effect"
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    background: isActive ? (opt.gradient ? `linear-gradient(135deg, ${THEME.omega}, ${THEME.supe})` : (opt.color || THEME.text)) : THEME.bg,
                    color: isActive ? '#000' : (opt.color || THEME.text),
                    border: `1px solid ${isActive ? 'transparent' : THEME.border}`,
                    borderRadius: '12px', padding: '14px 16px', fontSize: '15px', fontWeight: '600', cursor: 'pointer'
                  }}
                >
                  <span>{opt.label}</span>
                  <span style={{ opacity: 0.7, fontSize: '14px' }}>{opt.count}</span>
                </button>
              );
            })}
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default MobileStatusPicker;
